export const CUSTOM_MUSCLE_OPTIONS = [
  { id: "chest", label: "가슴", aliases: ["chest", "가슴", "흉근"] },
  { id: "upper_chest", label: "윗가슴", aliases: ["upper chest", "윗가슴", "상흉부"] },
  { id: "lower_chest", label: "아랫가슴", aliases: ["lower chest", "아랫가슴", "하흉부"] },
  { id: "back", label: "등", aliases: ["back", "등", "등전체"] },
  { id: "lats", label: "광배근", aliases: ["lats", "lat", "광배", "광배근"] },
  { id: "upper_back", label: "상부 등", aliases: ["upper back", "상부 등", "능형근", "대원근"] },
  { id: "lower_back", label: "하부 등", aliases: ["lower back", "하부 등", "기립근", "허리"] },
  { id: "traps", label: "승모", aliases: ["traps", "trap", "승모", "승모근"] },
  { id: "mid_traps", label: "중부 승모", aliases: ["mid traps", "중부 승모", "중승모"] },
  { id: "shoulders", label: "어깨(전체)", aliases: ["shoulders", "shoulder", "어깨", "숄더", "삼각근"] },
  { id: "front_delts", label: "전면 어깨", aliases: ["front delt", "전면 어깨", "앞어깨", "전면 삼각근"] },
  { id: "side_delts", label: "측면 어깨", aliases: ["side delt", "lateral delt", "측면 어깨", "옆어깨", "측면 삼각근"] },
  { id: "rear_delts", label: "후면 어깨", aliases: ["rear delt", "posterior delt", "후면 어깨", "뒷어깨", "후면 삼각근"] },
  { id: "biceps", label: "이두", aliases: ["biceps", "bicep", "이두", "이두근"] },
  { id: "triceps", label: "삼두", aliases: ["triceps", "tricep", "삼두", "삼두근"] },
  { id: "forearms", label: "전완근", aliases: ["forearms", "forearm", "전완", "전완근"] },
  { id: "abs", label: "복근", aliases: ["abs", "ab", "복근", "복부", "코어"] },
  { id: "quads", label: "대퇴사두", aliases: ["quads", "quad", "대퇴사두", "대퇴사두근", "앞벅지"] },
  { id: "hamstrings", label: "햄스트링", aliases: ["hamstrings", "hamstring", "햄스트링", "뒷벅지"] },
  { id: "glutes", label: "둔근", aliases: ["glutes", "glute", "둔근", "엉덩이", "힙"] },
  { id: "calves", label: "종아리", aliases: ["calves", "calf", "종아리"] },
];
